var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};


site.frontpage = {
	init: function() {
		site.owl.init('#front-banner ul', {
			loop: true,
			nav: true,
			dots:true,
			margin:30,
			autoHeight: true,
			center:true,
			navText:["",""],
			items: 1,
			autoplay:true,
			autoplayTimeout:9000,
			smartSpeed: 2000 // duration of change of 1 slide
		});
	}
};

site.resources = {
	init: function() {
		site.resources.initFilter();
	},

	initFilter: function() {
		var $grid = $('#extras .items').isotope({
				itemSelector: '.item',
				layoutMode: 'fitRows',
			}),

			activeFilters = {},

			getComboFilter =function () {
				var combo = [];
				for (var prop in activeFilters) {
					var group = activeFilters[prop];
					if (!group.length) {
						continue;
					}
					if (!combo.length) {
						combo = group.slice(0);
						continue;
					}
					var nextCombo = [];
					// splitta hópum í combo: [ A, B ] & [ 1, 2 ] => [ A1, A2, B1, B2 ]
					for (var i = 0; i < combo.length; i++) {
						for (var j = 0; j < group.length; j++) {
							var item = combo[i] + group[j];
							nextCombo.push(item);
						}
					}
					combo = nextCombo;
				}
				return combo.join(', ');
			},
			addActiveFilter = function(group, filter) {
				var filterGroup = activeFilters[ group ];
				if ( !filterGroup ) {
					filterGroup = activeFilters[ group ] = [];
				}
				filterGroup.push(filter);
			},
			removeActiveFilter = function(group, filter) {
				var filterGroup = activeFilters[ group ];
				if ( !filterGroup ) {
					filterGroup = activeFilters[ group ] = [];
				}
				var index = filterGroup.indexOf( filter );
				filterGroup.splice( index, 1 );
			};


		$('.itemFilter').on('click', 'a', function(e) {
			e.preventDefault();
			var $this = $(this);
			var filterValue = '.' + $this.attr('href').slice(1);

			if ($this.hasClass('all')) {
				if (!$this.hasClass('selected')) {
					$this.siblings().each(function() {
						var $sibling = $(this);
						$sibling.removeClass('selected');
						if($(this).hasClass('single')) {
							removeActiveFilter('single', filterValue);
						}
						else {
							removeActiveFilter('many', filterValue);
						}
					});
					$this.addClass('selected');
				}
			}
			else {
				$(this).closest('div').find('.all').removeClass('selected');

				if (!$this.hasClass('selected')) {
					$this.addClass('selected');

					if ($this.hasClass('single')) {
						$this.siblings().each(function() {
							var $sibling = $(this);
							$sibling.removeClass('selected');
							removeActiveFilter('single', '.' + $sibling.attr('href').slice(1));
						});
					}
					if ($this.hasClass('single')) {
						addActiveFilter('single', filterValue);
					}
					else {
						addActiveFilter('many', filterValue);
					}
				}
				else {
					$this.removeClass('selected');
					if($(this).hasClass('single')) {
						removeActiveFilter('single', filterValue);
					}
					else {
						removeActiveFilter('many', filterValue);
					}
				}
			}

			if (activeFilters.length === 0) {
				$(this).closest('div').find('.all').addClass('selected');
			}

			$this.blur();
			$grid.isotope({ filter: getComboFilter() });
		});
	}
};

site.participants = {
	activeFilters : [],

	init: function() {
		site.participants.initFilter();
	},

	initFilter: function() {
		var $grid = $('.companies').isotope({
			itemSelector: '.company',
			layoutMode: 'vertical'
		});

			activeFilters = {},

			getComboFilter = function () {
				var combo = [];
				for (var prop in activeFilters) {
					var group = activeFilters[prop];
					if (!group.length) {
						continue;
					}
					if (!combo.length) {
						combo = group.slice(0);
						continue;
					}
					var nextCombo = [];
					// splitta hópum í combo: [ A, B ] & [ 1, 2 ] => [ A1, A2, B1, B2 ]
					for (var i = 0; i < combo.length; i++) {
						for (var j = 0; j < group.length; j++) {
							var item = combo[i] + group[j];
							nextCombo.push(item);
						}
					}
					combo = nextCombo;
				}
				var comboFilter = combo.join(', ');
				return comboFilter;
			},
			addActiveFilter = function(group, filter) {
				var filterGroup = activeFilters[ group ];
				if ( !filterGroup ) {
					filterGroup = activeFilters[ group ] = [];
				}
				filterGroup.push(filter);
			},
			removeActiveFilter = function(group, filter) {
				var filterGroup = activeFilters[ group ];
				if ( !filterGroup ) {
					filterGroup = activeFilters[ group ] = [];
				}
				var index = filterGroup.indexOf( filter );
				filterGroup.splice( index, 1 );
			};


		$('.itemFilter').on('click', 'a', function(e) {
			e.preventDefault();
			var $this = $(this);
			var filterValue = '.' + $this.attr('href').slice(1);

			if ($this.hasClass('all')) {
				if (!$this.hasClass('selected')) {
					$this.siblings().each(function() {
						var $sibling = $(this);
						$sibling.removeClass('selected');
						if($(this).hasClass('single')) {
							removeActiveFilter('single', filterValue);
						}
						else {
							removeActiveFilter('many', filterValue);
						}
					});
					$this.addClass('selected');
				}
			}
			else {
				$(this).closest('div').find('.all').removeClass('selected');

				if (!$this.hasClass('selected')) {
					$this.addClass('selected');

					if ($this.hasClass('single')) {
						$this.siblings().each(function() {
							var $sibling = $(this);
							$sibling.removeClass('selected');
							removeActiveFilter('single', '.' + $sibling.attr('href').slice(1));
						});
					}
					if ($this.hasClass('single')) {
						addActiveFilter('single', filterValue);
					}
					else {
						addActiveFilter('many', filterValue);
					}
				}
				else {
					$this.removeClass('selected');
					if($(this).hasClass('single')) {
						removeActiveFilter('single', filterValue);
					}
					else {
						removeActiveFilter('many', filterValue);
					}
				}
			}

			if (activeFilters.length === 0) {
				$(this).closest('div').find('.all').addClass('selected');
			}

			$this.blur();
			$grid.isotope({ filter: getComboFilter() });
		});
	}
};


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.megamenu.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px; text-align: center; margin: 0 auto;"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
